/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function createNewTransporter(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters`, {
    method: "POST",
    data: params,
  });

  return result?.data;
}

export async function registerTransporter(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/register`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getAllTransporters({
  page = 1,
  pageSize = 10,
  filter = "",
  flagStatus,
  dotNumber,
  employerIdentificationNumber,
  mcNumber,
  w9FileUrl,
  cliFileUrl,
  stateId,
  city,
  rating,
  sorting,
}) {
  page--;

  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const SkipCount = page * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    DOTNumber: dotNumber,
    EmployerIdentificationNumber: employerIdentificationNumber,
    MCNumber: mcNumber,
    W9FileUrl: w9FileUrl,
    CLIFileUrl: cliFileUrl,
    StateId: stateId,
    City: city,
    Status: flagStatus,
    Rating: rating,

    Sorting,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getTransporterById(transporterId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/${transporterId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getTransporterRMIS(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/rmis/${params}`, {
    method: "GET",
  });

  return result?.data;
}

export async function updateTransporter(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/${data.id}`, {
    method: "PUT",
    data: { ...data },
  });

  return result?.data;
}

export async function updateW9File(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/w9/${params.id}`, {
    method: "PUT",
    params: params.file,
  });

  return result?.data;
}

export async function updateCOIFile(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/coi/${params.id}`, {
    method: "PUT",
    params: params.file,
  });

  return result?.data;
}

export async function updateStaus(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company/${params.id}/status`, {
    method: "PUT",
    data: params.data,
  });

  return result?.data;
}

export async function updateRatingTransporters(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/update-rating`, {
    method: "PATCH",
    data: params.data,
    params: { id: params.id },
  });

  return result?.data;
}

export async function getInfoFromDOT(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/info-from-dot`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function getTransportersAllowed({ page = 1, pageSize = 10, filter = "", canSelfDispatch, status }) {
  page--;

  const SkipCount = page * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filter || undefined,
    CanSelfDispatch: canSelfDispatch,
    Status: status,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/allowed`, {
    params,
  });

  return result?.data;
}

export async function getTransporterAllowedById(transporterId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/allowed/${transporterId}`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function requestTransporterInfoChange(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/transporters/request-info-change`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result;
}
